import { v4 as uuidv4 } from "uuid";
import i18n from "@/plugins/i18n";
import { XmlDocumentWrapper } from "@/utilities/xml-helpers/xml-document-wrapper";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { CovariateValue } from "./computation/covariate-value";
import { Drug } from "./computation/drug";
import { Request } from "./computation/request";
import { RequestModelInterface } from "../request-model-interface";

export class ComputationQuery implements RequestModelInterface
{
    public get clientId(): string
    {
        return `TucuxiWeb_${process.env.VUE_APP_VERSION}`;
    }

    public queryId: string;
    public date: Date;
    public covariates: CovariateValue[] = [];
    public drugs: Drug[] = [];
    public requests: Request[] = [];

    public constructor()
    {
        this.queryId = uuidv4();
        this.date = new Date();
    }

    public getXml(doc: XmlDocumentWrapper): XmlElementWrapper
    {
        const queryElement = doc.createElement("query");

        queryElement.appendNewElement("queryId", this.queryId);
        queryElement.appendNewElement("clientId", this.clientId);
        queryElement.appendNewElement("date", this.date.toISOString());
        queryElement.appendNewElement("language", i18n.global.locale.value);

        // <treatment> subnode
        const treatementElement = queryElement.appendNewElement("drugTreatment");
        const patientElement = treatementElement.appendNewElement("patient");
        const covariatesElement = patientElement.appendNewElement("covariates");
        const drugsElement = treatementElement.appendNewElement("drugs");

        covariatesElement.appendChildren(this.covariates);
        drugsElement.appendChildren(this.drugs);

        // <requests> subnode
        const requestsElement = queryElement.appendNewElement("requests");

        requestsElement.appendChildren(this.requests);

        return queryElement;
    }
}
